import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark } from '@fortawesome/free-solid-svg-icons';

export default function BookmarkFilledIcon(props) {
  return <FontAwesomeIcon icon={faBookmark} {...props} />;
}
